import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import React from "react";
import {
  AssetPreview,
  ContentTypeIcon,
  EditableLabel,
} from "signoxe/components";
import { updateAsset, moveAssets } from "signoxe/actions";
import { Icon } from "signoxe/components/widgets";
import { AssetPropType } from "signoxe/constants/propTypes";
import "./styles.scss";

import Dropdown from 'rc-dropdown';
import Menu, {MenuItem} from 'rc-menu';
import 'rc-dropdown/assets/index.css';

const AssetTile = ({
  asset,
  selected,
  editable,
  showIcon,
  onChange,
  onClickDelete,
  onClick,
  isCampaignView,
  campaign,
  onRemove,
  folders,
  updateAsset,
  isChecked,
  isMakerChecker,
  moveAssets,
}) => {
  const assetType = (asset.type || "").toLowerCase();

  // useEffect(() => {
  //   return () => {
  //     // Clean up any asynchronous tasks or subscriptions here
  //   };
  // }, []);

  const moveItem = (id) => {
    moveAssets(id, [asset.id]);

    // updateAsset(asset.id, {
    //   name: asset.name,
    //   campaign: id,
    // }).catch((error) => {
    //   console.error("Error updating asset:", error);
    // });
  };

  // console.log("Uncheck", isChecked)
  const menu = (
   
    <Menu style={{padding: '5px', fontSize: '15px' }}>
      <button key={-1} disabled>
            Move items(s) to one of the folders below:
      </button>
      {folders.length > 0 ?
        folders.map((data, index) => (
          <MenuItem style={{cursor: 'pointer'}} key={index} onClick={() => moveItem(data.id)}>{data.name}</MenuItem>
        )) 
        :
        'No folders'
    }
      
    </Menu>
 
  );

  // console.log("type", folders)

  return (
    <Dropdown
        trigger={['contextMenu']}
        overlay={menu}
        animation="slide-up"
        alignPoint
      >
    <div className={classNames("asset-tile", { selected })} style={{backgroundColor: (isChecked && asset.color < 1) ? 'red' : 'white'}}>
      {isMakerChecker && <>
       {asset.status === "approved" && (
          <i className="maker_checker_status fas fa-circle-check status status-approved"></i>
        )}
        {asset.status === "pending" && (
          <i className=" maker_checker_status fas fa-clock-o status status-pending"></i>
        )}
        {asset.status === "rejected" && (
          <i className=" maker_checker_status fas fa-times-circle-o status status-rejected"></i>
        )}
        {asset.status == null && (
          <i className=" maker_checker_status fas fa-minus status-pending"></i>
        )} </>}

      {showIcon && (
        <div className="icon-container">
          <div className="type-icon">
            <ContentTypeIcon type={asset.type} />
          </div>
        </div>
      )}
      <AssetPreview asset={asset} onClick={() => onClick && onClick(asset)} />
      <div className={classNames("type", assetType)}>
        {isCampaignView && editable && onClickDelete && (
          <Icon
            title="Remove from campaign"
            name="level-up"
            size="1.25rem"
            color="black"
            className="pointer"
            onClick={() => onRemove(asset, campaign)}
          />
        )}
        <EditableLabel
          value={asset.name}
          enabled={editable && !!onChange}
          onChange={(newValue) => onChange({ ...asset, name: newValue })}
        />
        {editable && onClickDelete && (
          <Icon
            title="Delete"
            name="trash"
            size="1.25rem"
            color="black"
            onClick={() => onClickDelete(asset)}
          />
        )}
      </div>
    </div>
    </Dropdown>
  );
};

AssetTile.propTypes = {
  asset: AssetPropType.isRequired,
  selected: PropTypes.bool.isRequired,
  showIcon: PropTypes.bool.isRequired,
  isChecked: PropTypes.bool.isRequired,
  editable: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onClickDelete: PropTypes.func,
};

export default connect(null, {updateAsset, moveAssets})(AssetTile);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetTile/index.js